'use client';
import { useRouter, useSearchParams } from '@/navigation';
import { TableRow, TableCell } from '@mui/material';

import { useCallback } from 'react';

export interface Props {
  sku: string;
  dimensions: { [name: string]: string };
  productOptions: string[];
  active?: boolean;
  basePath: string;
}

export function ProductVariant({ sku, dimensions, productOptions, active, basePath }: Props) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const selectVariant = useCallback(() => {
    const query = new URLSearchParams({ ...Object.fromEntries(searchParams), sku });
    router.push(`${basePath}?${query.toString()}`);
  }, [router, basePath, searchParams, sku]);

  return (
    <TableRow selected={active} hover sx={{ cursor: 'pointer' }} onClick={selectVariant}>
      <TableCell sx={{ fontSize: '.875rem' }}>{sku}</TableCell>
      {productOptions.map(opt => (
        <TableCell key={`${opt}-${dimensions[opt]}`} align="right" sx={{ fontSize: '.875rem' }}>
          {dimensions[opt]}
        </TableCell>
      ))}
    </TableRow>
  );
}
